import React from 'react'

import Table from 'components/common/Table'
import * as Conf from './conf'

const Columns = ({ chosenAttributes, mapping, setMapping }) => {
  return (
    <Table
      headers={Conf.COLUMN_OPERATION_HEADERS(mapping, setMapping)}
      rows={Conf.getColumnOperationRows(chosenAttributes, mapping)}
      parsedFormat
    />
  )
}

export default Columns
